<template>
  <section class="w-full h-full flex flex-col items-center overflow-hidden">
    <div class="w-660 mt-8">
      <el-steps class="horizontal-steps" :active="step === 6 ? 2 : step" finish-status="success" simple>
        <el-step title="选择收信人">
          <span slot="icon">1</span>
        </el-step>
        <el-step title="选择短信内容">
          <span slot="icon">2</span>
        </el-step>
        <el-step title="发布短信">
          <span slot="icon">3</span>
        </el-step>
      </el-steps>
    </div>
    <div class="w-full flex-1 overflow-auto flex">
      <keep-alive exclude="StepPaySend">
        <component :is="componentName" />
      </keep-alive>
    </div>

    <!-- 改版后布局样式 -->
    <!-- <div class="flex w-full bg-bg-common-color h-full">
      <div class="w-full flex-1 overflow-auto flex bg-white flex-col">
        <div class="w-full justify-center flex">
          <div class="w-660 mt-8">
            <el-steps class="horizontal-steps" :active="step === 6 ? 2 : step" finish-status="success" simple>
              <el-step title="选择收信人">
                <span slot="icon">1</span>
              </el-step>
              <el-step title="选择短信内容">
                <span slot="icon">2</span>
              </el-step>
              <el-step title="发布短信">
                <span slot="icon">3</span>
              </el-step>
            </el-steps>
          </div>
        </div>
        <keep-alive exclude="StepPaySend">
          <component :is="componentName" />
        </keep-alive>
      </div>
      <div class="right-aside h-full ml-4 bg-white overflow-auto pb-4">
        <RightAside />
      </div>
    </div> -->

  </section>
</template>

<script>
import StepRecipient from './StepRecipient'
import StepSms from './StepSms'
import StepPaySend from './StepPaySend'
import StepPayResult from './StepPayResult'
import StepPayUnderReview from './StepPayUnderReview'
import StepPayReject from './StepPayReject'
import RightAside from '@/views/survey/publish/sms-approve/RightAside.vue'

// 短信审批相关组件
import ExamineProcess from '@/views/survey/publish/sms-approve/ExamineProcess.vue'

export default {
  name: 'SmsBatch',
  components: {
    StepRecipient,
    StepSms,
    StepPaySend,
    StepPayResult,
    StepPayUnderReview,
    StepPayReject,
    ExamineProcess,
    RightAside
  },
  props: {
    step: {
      type: Number,
      default: 0
    }
  },
  computed: {
    componentName() {
      return (
        {
          0: 'step-recipient',
          1: 'step-sms',
          2: 'step-pay-send',
          3: 'step-pay-under-review',
          4: 'step-pay-result',
          5: 'step-pay-reject',
          6: 'examine-process'
        }[this.step] || null
      )
    }
  },
}
</script>

<style lang="scss" scoped>
.w-660 {
  width: 660px;
}
.right-aside{
  width: 290px;
}
</style>
